import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx={12} cy={12} r={8} fill="currentColor" />
    <path
      d="M7.577 12.207l1.487-1.414 1.885 1.793L14.719 9l1.487 1.414-5.257 5-3.372-3.207z"
      fill="#fff"
    />
  </svg>
);
